import { render, staticRenderFns } from "./LoginAccount.vue?vue&type=template&id=fb183210&scoped=true&"
import script from "./LoginAccount.vue?vue&type=script&lang=js&"
export * from "./LoginAccount.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb183210",
  null
  
)

export default component.exports